import { Component, OnInit, Input } from '@angular/core';
import { DataModalComponent } from '../data-modal/data-modal.component';

import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { ContractorService } from '../../services/contractor/contractor.service';

import _ from 'lodash';

@Component({
	selector: 'pcm-data-modal-merge-contractor',
	templateUrl: './data-modal-merge-contractor.component.html',
	styleUrls: [
		'../data-modal/data-modal.component.scss',
		'./data-modal-merge-contractor.component.scss'
	]
})
export class DataModalMergeContractorComponent extends DataModalComponent implements OnInit {

	@Input() contractor;

	mergeContractor;
	contractors = [];
	contractorColumnsConfig = [];

	constructor(
		public dataService: DataService,
		public configService: ConfigService,
		public contractorService: ContractorService
	) {
		super(configService);
	}

	ngOnInit() {
		console.log('DATA MODAL MERGE CONTRACTOR INIT', this.contractor, this.dataService.poContractors);
		this.contractorColumnsConfig = this.configService.getTableFields(this.contractorService.dataObj, true);
		this.contractorService.selectActiveTab(this.contractorService.tabsData.poListTabs, this.contractorService.getPOAllTab().prop);
		this.mergeContractor = _.cloneDeep(this.contractor);
		const contractors = [];
		// pending contractors cant be used for now
		// since pending is based on actions for user not all pending users
		// const pendingContractors = _.cloneDeep(this.dataService.poPendingContractors);
		const pendingContractors = _.cloneDeep(this.dataService.poContractors);
		const self = this;
		pendingContractors.forEach(function (d, i) {
			if (!_.isEqual(d, self.contractor) && d[self.configService.contractorLineItemProp] === self.contractor[self.configService.contractorLineItemProp]) {
				contractors.push(d);
			} else {
				console.log('FOUND SAME MERGE CONTRACTOR', d);
			}
		});
		this.contractors = contractors;
	}

	buildSubmitEvent(event) {
		const mergingContractor = this.dataService.selectedTableRows[0];
		const self = this;

		console.log('BUILD MERGE SUBMIT EVENT', this.contractorService.dataConfig['fields'], mergingContractor, self.mergeContractor);

		// MERGE DEFAULT FIELDS
		this.contractorService.dataConfig['fields'].forEach(function (d, i) {
			if (mergingContractor[d.prop] !== '' && d.prop !== self.configService.uuidProp) {
				console.log('MERGE FIELD', d.prop, mergingContractor[d.prop]);
				self.mergeContractor[d.prop] = mergingContractor[d.prop];
			}
		});

		// MERGE ACL PARTICIPANTS
		this.configService.roles.forEach(function (role, roleI) {

			if (self.mergeContractor['acl'] !== undefined) {
				if (self.mergeContractor['acl'][role.id] !== undefined) {
					if (self.mergeContractor['acl'][role.id]['participants'] !== undefined) {
						const roleParticipants = [];

						self.mergeContractor['acl'][role.id]['participants'].forEach(function (part, partI) {
							if (part !== '') {
								roleParticipants.push(part);
							}
						});

						mergingContractor['acl'][role.id]['participants'].forEach(function (part, partI) {
							if (part !== '') {
								let samePart = false;
								roleParticipants.forEach(function (rolePart, rolePartI) {
									if (part === rolePart) {
										samePart = true;
									}
								});
								if (!samePart) {
									roleParticipants.push(part);
								}
							}
						});

						self.mergeContractor['acl'][role.id]['participants'] = roleParticipants;
					}
				}
			}

		});

		const submitEvent = {
			event: event,
			data: this.mergeContractor,
			remove: mergingContractor[this.configService.uuidProp]
		};

		return submitEvent;
	}

	tableClick(event) {
		console.log('MERGE CONTRACTOR MODAL TABLE CLICK');
	}

}
